import http from '@/uteis/http'

export default class InteressadoService {
  async consultarInteressado (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes', { params: filtro }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes', { params: filtro }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarServidor (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/cadastrados', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/cadastrados', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async toEmpresa (data, cnpj) {
    const endereco = {
      numero: data.contribuinte.pessoa.pessoaEndereco.numero,
      rua: data.contribuinte.pessoa.pessoaEndereco.logradouro,
      cep: data.contribuinte.pessoa.pessoaEndereco.cep,
      estado: data.contribuinte.pessoa.pessoaEndereco.uf,
      cidade: data.contribuinte.pessoa.pessoaEndereco.municipio || data.contribuinte.pessoa.pessoaEndereco.cidadeExterior,
      bairro: data.contribuinte.pessoa.pessoaEndereco.bairro,
      complemento: data.contribuinte.pessoa.pessoaEndereco.complemento
    }

    const empresa = {
      nome: data.contribuinte.pessoa.nome,
      identificador: data.cnpj || data.contribuinte.inscricaoEstadual,
      email: data.contribuinte.pessoa.email,
      telefone: data.contribuinte.pessoa.telefone2_Comercial,
      tipoContatoExterno: data.contribuinte.inscricaoEstadual === cnpj ? 'INSCRICAOESTADUAL' : 'PESSOAJURIDICA',
      fontInformacao: 'CCE',
      endereco: endereco
    }

    return empresa
  }

  async buscarEmpresa (filtro) {
    if (filtro.cnpj === '') {
      return
    }
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/cce', { params: filtro }).then((response) => {
        var result = response.data.data[0]
        var empresa = this.toEmpresa(result, filtro.cnpj)

        return resolve(empresa)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/cce', { params: filtro }).then((response) => {
          var result = response.data.data[0]
          var empresa = this.toEmpresa(result, filtro.cnpj)

          return resolve(empresa)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarContatoExterno (idContatoExterno) {
    var url = `/d0593/pae-back/v1/participantes/${idContatoExterno}`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async novo (values) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/participantes', values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/participantes', values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async editar (id, values) {
    return new Promise((resolve, reject) => {
      http.put(`/d0593/pae-back/v1/participantes/${id}`, values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.put(`/d0593/pae-back/v1/participantes/${id}`, values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async excluir (id) {
    return new Promise((resolve, reject) => {
      http.delete(`/d0593/pae-back/v1/participantes/${id}`).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.delete(`/d0593/pae-back/v1/participantes/${id}`).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
